import { Component, Input, HostBinding, Output, EventEmitter, OnChanges, SimpleChanges, AfterViewInit } from '@angular/core';
import { ApiService } from 'app/services/api.service';

@Component({
  selector: 'app-keyboard',
  templateUrl: './keyboard.component.html',
  styleUrls: ['./keyboard.component.css']
})
export class KeyboardComponent implements OnChanges {
  constructor(private aspiservice : ApiService) {
    this.aspiservice.cursorposition.subscribe((data)=>{
      this.cursorPosition = data;
    })
   }
  @Input() lastInput: string;
  @Input() cursorPosition: number;
  @Output() valueChange = new EventEmitter<string>();
  @Output() hidekeyboardvalue = new EventEmitter<boolean>();
  characters = [
    ['1','2','3','4','5','6','7','8','9','0'],
    ['Q', 'W', 'E', 'R', 'T', 'Y', 'U', 'I', 'O', 'P'],
    ['A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L'],
    ['Z', 'X', 'C', 'V', 'B', 'N', 'M', 'back','hide'],
  ];



  ngOnChanges(changes: SimpleChanges) {
    if (changes.lastInput) {
      this.chars = this.lastInput.split('');
      this.combinedString = this.chars.join('');
    }
    if(changes.cursorPosition){
    }
  }

  // enterCharacter(char: string) {
  //   if (this.lastInput) {
  //     const chars = this.lastInput.value.split('');
  //     chars.splice(this.cursorPosition, 0, char);
  //     this.lastInput.value = chars.join('');
  //     this.cursorPosition += 1;
  //     this.lastInput.setSelectionRange(this.cursorPosition, this.cursorPosition);
  //     this.lastInput.focus();
  //   }
  // }
  chars = []
  combinedString;
  // enterCharacter(char: string) {
  //   if(char){
  //     this.chars.push(char);
  //     this.combinedString = this.chars.join('');
  //     this.valueChange.emit(this.combinedString);
  //   }else{
  //     if (this.chars.length) {
  //       this.chars.pop();
  //       this.combinedString = this.chars.join('');
  //       this.valueChange.emit(this.combinedString);
  //     }
  //   }
  // }

  enterCharacter(char: string) {
    if(this.combinedString.length == 0){
      this.cursorPosition = 0;
    }
    if (char) {
        this.chars.splice(this.cursorPosition, 0, char);
        this.cursorPosition++;
    } else {
        // Remove character at the cursor position if there's something to remove
        if (this.chars.length && this.cursorPosition > 0) {
            this.chars.splice(this.cursorPosition - 1, 1);
            this.cursorPosition--; 
        }
    }

    this.combinedString = this.chars.join('');
    this.valueChange.emit(this.combinedString);
  }


  backclicked(event){
    if(event){
      if (this.chars.length && this.cursorPosition > 0) {
        this.chars.splice(this.cursorPosition - 1, 1);
        this.cursorPosition--; 
    }
    }
  }

  hidekeyboard(){
    this.hidekeyboardvalue.emit(false)
  }

  clearCharacter() {
    
  }
}